const BlogLanding = (() => {
    function filterSwipeIndicator() {
        $('.filter-wrapper').on('scroll', () => {
            $('.filter-wrapper').addClass('no-indicator');
        });
    }
    return {
        init() {
            filterSwipeIndicator();
        },
    };
})();

export default (() => {
    $(document).ready(BlogLanding.init);
})();
